import { registerPlugin } from '@capacitor/core';

export interface PersistentDevicePlugin {
    getId(): Promise<{ identifier: string }>;
}

export const PersistentDevice = registerPlugin<PersistentDevicePlugin>(
    'PersistentDevice'
);
